const bodyScrollLock = require('body-scroll-lock');
const {parseResponse} = require("../components/bn_forms");

function openSwiperPopup(selector) {
    let wrapper = $('.swiper-popup');

    if (selector) {
        wrapper = $(selector);
    }

    bodyScrollLock.disableBodyScroll(wrapper.find('.swiper-popup__container').get(0));

    wrapper.addClass('open');

    let swipeArea = wrapper.find('.swiper-popup__swipe-area').get(0),
        bookSwiperBlock = wrapper.find('.swiper-popup__wrapper').get(0),
        swiperHeight = bookSwiperBlock.offsetHeight;

    if (typeof LitnetApp !== 'undefined') {
        LitnetApp.openBookDetails();
    }

    swipeArea.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length == 1) {
            let touch = event.targetTouches[0],
                touchY = touch.clientY - 260;

            if (touchY < 0) {
                return false;
            }

            bookSwiperBlock.style.transform = "translateY(" + touchY + "px)";

            let translateY = bookSwiperBlock.style.transform
            translateY = translateY.replace(/[^\d.]/g, '');

            if (translateY > ((swiperHeight / 100) * 30 )) {
                $('.swiper-popup').removeClass('open');
                bookSwiperBlock.style.transform = null;
                bodyScrollLock.clearAllBodyScrollLocks();
                saveStatisticToDb('close_swipe', 'swiper')
            }
        }
    }, false);

    swipeArea.addEventListener('touchend', function (event) {
        bookSwiperBlock.style.removeProperty('transform');
    })
}

function closeSwiperPopup () {
    $('.swiper-popup').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    if (typeof LitnetApp !== 'undefined') {
        LitnetApp.closeBookDetails();
    }
}

$(document).on('click', '[data-swipe-book-id]', function (event) {
    let that = $(this),
        collectionId = that.data('collection-id'),
        swiper = $('.swiper-popup.dynamic'),
        wrapper = swiper.find('.swiper-popup__wrapper'),
        bookId = that.data('swipe-book-id'),
        href = that.attr('href'),
        moreClass = that.data('more-class'),
        readerClass = that.data('reader-class');

    if (!wrapper.length) return;

    event.preventDefault();

    $.ajax({
        'type': 'POST',
        'url': '/book/get-swipe-popup',
        'data': {
            bookId: bookId,
            collectionId: collectionId,
            readerClass: readerClass,
            moreClass: moreClass,
        },
        'beforeSend': function () {
            wrapper.html('');
        },
        'success': function (result) {
            if (result.status === 'success') {
                wrapper.prepend(result.data);

                openSwiperPopup('.swiper-popup.dynamic');

                saveStatisticToDb('open', 'swiper');
            } else {
                window.location.href = href;
            }
        },
        'error': function (jqXHR) {
            if (jqXHR.status === 0) {
                window.location.reload();
            }
        },
    });
})

$(document).on('click', '.swiper-popup__close', function () {
    closeSwiperPopup();
});

$(document).on('click', '.swiper-popup', function (event) {
    if ($(event.target).closest('[data-swipe-book-id], .swiper-popup__wrapper, .modal').length) return;

    if (!$(this).hasClass('open')) return;

    saveStatisticToDb('close_outside', 'swiper')

    closeSwiperPopup();
});

$(document).on('click', '.swiper-popup__controls-bookmark', function () {
    let that = $(this),
        url = that.data('library-add'),
        collectionId = that.data('collection-id'),
        bookId = that.data('book-id');

    if (that.hasClass('active')) {
        return;
    }

    $.ajax({
        'dataType': 'json',
        'type': 'POST',
        'url': url,
        'data': {
            bookId: bookId,
            collectionId: collectionId,
        },
        'success': function (response) {
            that.addClass('active');
            parseResponse(response);
        },
        'error': function () {
            console.error('Bookmark ajax error')
        },
    });
})

$(document).on('click', '.gaPushBuy', function (event) {
    saveStatisticToDb('buy', 'swiper');
})

$(document).on('click', '.gaPushRead', function (event) {
    saveStatisticToDb('read', 'swiper');
})

$(document).on('click', '.searchReadAction', function (event) {
    saveStatisticToDb('read', 'search_stat', new URLSearchParams(window.location.search).has('app'));
})

$(document).on('click', '.searchMoreAction', function (event) {
    saveStatisticToDb('more', 'search_stat', new URLSearchParams(window.location.search).has('app'));
})

window.openSwiperPopup = function (selector) {
    openSwiperPopup(selector);
};

window.closeSwiperPopup = function () {
    closeSwiperPopup();
};

